<template>
  <span
    class="flex form-field sm:w-80 w-full px-3 py-2 mt-1 sm:mt-0 bg-white shadow"
  >
    <input
      name="search"
      class="focus:outline-none flex-grow"
      v-model="searchKeyword"
      @input="onSearchInput"
      :placeholder="getPlaceholder"
      v-bind="$attrs"
    />
    <SearchIcon class="h-6 inline text-gray-500 flex-none" />
  </span>
</template>

<script>
import { ref } from "@vue/reactivity";
import { SearchIcon } from "@heroicons/vue/solid";
import { debounce } from "lodash";

export default {
  name: "SearchInput",
  inheritAttrs: false,
  emits: ["update:modelValue", "input"],
  components: {
    SearchIcon,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      require: false,
    },
    // Opt in to letting the parent drive the input, so clearing `modelValue`
    // from outside also clears the visible text. Off by default: several
    // consumers reset their bound value mid-typing (UploadModal clears it
    // whenever fewer than 3 characters have been typed), and syncing that back
    // would wipe out what the user was in the middle of typing.
    syncModelValue: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { searchKeyword: ref("") };
  },
  computed: {
    getPlaceholder() {
      return this.placeholder || "Search by Email";
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (this.syncModelValue && val !== this.searchKeyword) {
          this.searchKeyword = val ?? "";
        }
      },
    },
  },
  methods: {
    onSearchInput: debounce(function () {
      this.$emit("update:modelValue", this.searchKeyword);
      this.$emit("input", this.searchKeyword);
    }, 300),
  },
};
</script>
